<template>
    <div class="container-fluid">
        <route-header>
            <h3>{{ $t('labels.nav.customers') }}</h3>
            <div class="d-flex align-items-center">
                <bs-button v-if="auth.can['edit_customers']" class="btn-sm btn-info" @click="$refs.customers.create()">{{ $t('labels.action_customer',  { action: $t('labels.create') }) }}</bs-button>
            </div>
        </route-header>
        <div class="row">
            <div class="col-12">
                <customers ref="customers" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CustomerList',
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
}
</script>
